export default __webpack_public_path__ + "static/media/12.eccc1962.jpg";